// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".region-card[data-v-3dafd9b6]{height:105px;max-width:100%;position:relative;width:350px}.region-card__btn[data-v-3dafd9b6]{bottom:4px;position:absolute;right:7px}.region-card__btn--fullimage[data-v-3dafd9b6]{bottom:auto;top:50%;transform:translateY(-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
